import axios from 'axios';
import Vue from 'vue'

export default {

     getRequestAvoir (page, pageSize,customerId,status,start,end) {
        return axios.get('/api/avoir/request-list', { params: {page: page, pageSize: pageSize, customerId:customerId,status:status,start:start,end:end} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    }, 
    // article suggestions of the demande d'avoir form (id, ref, barcode, title, brand; no price or stock).
    // undefined when the server predates /api/avoir/items (the axios interceptor swallows the 404)
    findAvoirItems (search, limit) {
        return axios.get('/api/avoir/items', { params: {search: search, limit: limit} })
        .then(response => {
            if (response && Array.isArray(response.data)) return response.data
        })
    },
    getRequestAvoirById (avoirId) {
        return axios.get('/api/avoir/id', { params: {avoirId: avoirId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    }, 

    addRequestAvoir(avoirId , reason  , status) {
        const avoir= {
            avoirId : avoirId ,
            reason : reason ,
            quantityAvoir : null ,
            orderLineId : null ,
            orderExtId : null ,
            status: status,
        }

        return axios.post('/api/avoir/save',avoir)
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {
            Vue.prototype.$snotify.error(error);
        });
        },


    addRequestAvoirLine(avoir) {

        return axios.post('/api/avoir/add/line', avoir)
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {
            Vue.prototype.$snotify.error(error);
        });
        },

    validateRequestAvoir(avoir) {
        return axios.post('/api/avoir/validate', avoir)
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {
            Vue.prototype.$snotify.error(error);
        });
        },

    deleteAvoirRequestLine(avoir) {
        return axios.post('/api/avoir/delete/line', avoir)
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {
            Vue.prototype.$snotify.error(error);
        });
        },
    deleteAvoirRequestIfEmpty(avoirId) {
        return axios.get('/api/avoir/delete', { params: {avoirId: avoirId} })
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {
            Vue.prototype.$snotify.error(error);
        });
        }
 

}